import psPlatformClient from "../../psPlatformClient";
// import { AxiosError, AxiosResponse } from "axios";

export interface DmProjectFile {
    name: string;
    s3Key: string;
    createdAt: number;
    sendToDealRoom: boolean;
    fileType: string;
    comments?: string;
}

export interface DmProjectReport {
    s3Key: string;
    createdAt: number;
    fileName: string;
}

export interface DmProject {
    id: string;
    companyId: string;
    name: string;
    createdAt: number;
    status: string;
    files: DmProjectFile[];
    report?: DmProjectReport;
    notes?: string;
}

export enum DmProjectStatus {
    DRAFT = "draft",
    ACTIVE = "active",
    COMPLETED = "completed",
    CANCELLED = "cancelled",
}

export interface AddFileToProjectRequest {
    projectId: string;
    fileName: string;
    fileType: string;
    s3Key: string;
}

export const getDmProjects = async (): Promise<DmProject[]> => {
    const result = await psPlatformClient<null, DmProject[]>({
        method: "get",
        url: `/dm/projects`,
    });
    return result.data;
};

export const getDmProject = async (projectId: string): Promise<DmProject> => {
    const result = await psPlatformClient<null, DmProject>({
        method: "get",
        url: `/dm/projects/${projectId}`,
    });
    return result.data;
};

export const createDmProject = async (name: string): Promise<DmProject> => {
    const result = await psPlatformClient<{ name: string }, DmProject>({
        method: "post",
        url: `/dm/create-project`,
        data: { name },
    });
    return result.data;
};

export const updateDmProject = async (
    projectId: string,
    updates: Partial<Pick<DmProject, "name" | "status" | "report">>
): Promise<DmProject> => {
    const result = await psPlatformClient<Partial<Pick<DmProject, "name" | "status" | "report">>, DmProject>({
        method: "put",
        url: `/dm/projects/${projectId}`,
        data: updates,
    });
    return result.data;
};

export const deleteDmProject = async (projectId: string): Promise<void> => {
    await psPlatformClient<null, null>({
        method: "delete",
        url: `/dm/projects/${projectId}`,
    });
};

export const generateUploadUrl = async (fileName: string, fileType: string, projectId: string, entityType?: string): Promise<{ url: string, key: string, fileName: string }> => {
    const result = await psPlatformClient<{ fileName: string; fileType: string }, { url: string, key: string, fileName: string }>({
        method: "get",
        url: `/dm/generate-upload-url?fileName=${fileName}&fileType=${fileType}&projectId=${projectId}&entityType=${entityType}`,
    });
    return { url: result.data.url, key: result.data.key, fileName: result.data.fileName };
};

export const getPublicSignedUrl = async (s3Key: string): Promise<string> => {
    const result = await psPlatformClient<{ s3Key: string }, { url: string }>({
        method: "get",
        url: `/dm/get-public-signed-url?s3Key=${encodeURIComponent(s3Key)}`,
    });
    return result.data.url;
};

export const addFileToProject = async (request: AddFileToProjectRequest): Promise<DmProject> => {
    const result = await psPlatformClient<AddFileToProjectRequest, DmProject>({
        method: "post",
        url: `/dm/add-file-to-project`,
        data: request,
    });
    return result.data;
};

export const deleteFileFromProject = async (projectId: string, s3Key: string): Promise<DmProject> => {
    const result = await psPlatformClient<{ projectId: string, s3Key: string }, DmProject>({
        method: "delete",
        url: `/dm/projects/${projectId}/files/${encodeURIComponent(s3Key)}`,
    });
    return result.data;
};


export const getSyncKnowledgeBaseStatus = async (): Promise<any> => {
    const result = await psPlatformClient<{ projectId: string }, any>({
        method: "get",
        url: `/dm/sync-knowledge-base-status`,
    });
    return result.data;
};

export const queryLLM = async (projectId: string): Promise<any> => {
    const result = await psPlatformClient<{ projectId: string }, any>({
        method: "post",
        url: `/dm/query-llm`,
        data: { projectId },
    });
    return result.data;
};

export const updateDmProjectFile = async (
    projectId: string,
    s3Key: string,
    updates: Partial<Pick<DmProjectFile, "sendToDealRoom" | "comments">>
): Promise<DmProject> => {
    const result = await psPlatformClient<Partial<Pick<DmProjectFile, "sendToDealRoom" | "comments">>, DmProject>({
        method: "put",
        url: `/dm/projects/${projectId}/files/${encodeURIComponent(s3Key)}`,
        data: updates,
    });
    return result.data;
};